import { render } from "./CustomChatUI.vue?vue&type=template&id=4ad99754"
import script from "./CustomChatUI.vue?vue&type=script&lang=js"
export * from "./CustomChatUI.vue?vue&type=script&lang=js"

import "./CustomChatUI.vue?vue&type=style&index=0&id=4ad99754&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__